import { ApiVolopFunction } from 'api/types/ApiVolopFunction';
import { getJson } from 'utils/http';

export function apiFetchVolopFunctions(): Promise<ApiVolopFunction[]> {
  return getJson(`/data/website/volop-functions?lang=${CURRENT_LOCALE}`).then(
    // @ts-expect-error TS(2345): Argument of type '({ volopFunctions }: { volopFunc... Remove this comment to see the full error message
    ({ volopFunctions }) => volopFunctions,
  );
}
